import { Box, Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

export type SavingsStatCardAccent = 'primary' | 'secondary' | 'success' | 'default';
export type SavingsStatCardSize = 'default' | 'hero';

export interface SavingsStatCardProps {
  label: string;
  value: ReactNode;
  helper?: ReactNode;
  accent?: SavingsStatCardAccent;
  size?: SavingsStatCardSize;
  children?: ReactNode;
}

const accentColorMap: Record<SavingsStatCardAccent, string> = {
  primary: 'primary.main',
  secondary: 'secondary.main',
  success: 'success.contrastText',
  default: 'divider',
};

const SavingsStatCard: FC<SavingsStatCardProps> = ({
  label,
  value,
  helper,
  accent = 'default',
  size = 'default',
  children,
}) => {
  const isHero = size === 'hero';
  const accentColor = accentColorMap[accent];

  return (
    <Stack
      flex={1}
      sx={{
        // Design-Rollout 25.10.2026: Karte wie karteSx, Akzent als 3-px-Linie.
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderLeft: '3px solid',
        borderLeftColor: accentColor,
        borderRadius: '8px',
        p: isHero ? 6 : 4,
        gap: isHero ? 4 : 2,
      }}
    >
      <Typography variant="label">
        {label}
      </Typography>
      <Box
        sx={{
          typography: isHero ? 'titelGross' : 'seitentitel',
        }}
      >
        {value}
      </Box>
      {children}
      {helper && (
        <Typography variant="klein">
          {helper}
        </Typography>
      )}
    </Stack>
  );
};

export default SavingsStatCard;
